import { Button, IconButton, Paper, TextField } from "@mui/material";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import JurebLogo from "../../lib/assets/images/jureb-logo.png";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { RESET_PASS_VALIDATION } from "../../validations/auth";
import { useMutation } from "@tanstack/react-query";
import authservice from "../../service/authservice";
import BTNLoader from "../../lib/components/BTNLoader";
import errorHandler from "../../utils/errorHandler";
import { toast } from "react-toastify";
import pathnames from "../../constants/pathnames";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const defaultValues = {
  password: "",
  confirmPassword: "",
};

const UpdatePassword = () => {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const [visibility, setVisibility] = React.useState({
    password: false,
    confirmPassword: false,
  });

  const formHook = useForm({
    resolver: yupResolver(RESET_PASS_VALIDATION),
    mode: "all",
    defaultValues: defaultValues,
  });

  const errors = formHook.formState.errors;
  const control = formHook.control;
  const handleSubmit = formHook.handleSubmit;
  const token = searchParams.get("token");

  const mutation = useMutation({
    mutationFn: (data) => authservice.resetPassword(data),
    onError: ({ response }) => errorHandler(response),
    onSuccess: () => {
      toast.success("Password updated successfully, signin to continue");
      setTimeout(() => navigate(pathnames.SIGN_IN, { replace: true }), 3000);
    },
  });

  const { isPending } = mutation;
  return (
    <div style={{ minHeight: "100vh" }} className="d-flex align-items-center bg-light">
      <div className="container-xxl">
        <form action="" onSubmit={handleSubmit(save)}>
          <Paper className="border mx-auto my-5" style={{ maxWidth: 600 }}>
            <div className="p-3 mx-auto my-5" style={{ maxWidth: 400 }}>
              <div className="d-flex justify-content-center mb-3">
                <img src={JurebLogo} alt="Jureb" />
              </div>
              <div className="text-center fw-medium fs-4 mb-4">Set Password</div>

              <div className="mb-3">
                <label htmlFor="">
                  Enter New Password<span className="text-danger">*</span>
                </label>
                <Controller
                  name="password"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      fullWidth
                      variant="outlined"
                      placeholder="Enter password"
                      value={field.value}
                      type={visibility.password ? "text" : "password"}
                      onChange={(e) => field.onChange(e.target.value)}
                      helperText={errors["password"]?.message}
                      error={!!errors["password"]}
                      InputProps={{
                        endAdornment: (
                          <IconButton size="small" onClick={() => handleChangeVisibility("password")}>
                            {visibility.password ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        ),
                      }}
                    />
                  )}
                />
              </div>
              <div className="mb-5">
                <label htmlFor="">
                  Confirm Password<span className="text-danger">*</span>
                </label>
                <Controller
                  name="confirmPassword"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      fullWidth
                      variant="outlined"
                      placeholder="Confirm Password"
                      value={field.confirmPassword}
                      type={visibility.confirmPassword ? "text" : "password"}
                      onChange={(e) => field.onChange(e.target.value)}
                      helperText={errors["confirmPassword"]?.message}
                      error={!!errors["confirmPassword"]}
                      InputProps={{
                        endAdornment: (
                          <IconButton size="small" onClick={() => handleChangeVisibility("confirmPassword")}>
                            {visibility.confirmPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        ),
                      }}
                    />
                  )}
                />
              </div>

              <div className="mb-3 mx-auto" style={{ maxWidth: 300 }}>
                <Button
                  type="submit"
                  fullWidth
                  disabled={isPending}
                  variant="contained"
                  color="secondary"
                  startIcon={<BTNLoader isLoading={isPending} />}
                >
                  Save
                </Button>
                <div className="my-3 text-center">
                  <Link to={pathnames.SIGN_IN} className="text-primary">
                    Back to Login
                  </Link>
                </div>
              </div>
            </div>
          </Paper>
        </form>
      </div>
    </div>
  );

  async function save(data) {
    delete data.confirmPassword;
    data.token = token;
    mutation.mutate(data);
  }
  function handleChangeVisibility(name) {
    setVisibility((prev) => ({ ...prev, [name]: !prev[name] }));
  }
};

export default UpdatePassword;
